module.exports = __webpack_public_path__ + "school/img/enTrainDetail.4c6412e2.jpg";